/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'stringify' } )
export class StringifyPipe implements PipeTransform {
    
    transform( pObjects: object[], pShowFields = 'Name' ): string {
        let result = '';
        if ( pObjects ) {
            pObjects.forEach( pObject => {
                result += result.length > 0 ? ', ' : '';
                
                let j = 0;
                pShowFields.split( ',' ).forEach( pField => {
                    if ( pField.includes( '.' ) ) {
                        let subFields = pField.split( '.' );
                        if ( pObject[ subFields[ 0 ] ] ) {
                            result += ( j > 0 ? ': ' : '' ) + pObject[ subFields[ 0 ] ][ subFields[ 1 ] ];
                            j++;
                        }
                    }
                    else {
                        if ( pObject[ pField ] ) {
                            result += ( j > 0 ? ': ' : '' ) + pObject[ pField ];
                            j++;
                        }
                    }
                } );
            } );
        }
        return result;
    }
}
